export const USER_AUTHENTICATION_COLLECTION = 194;
export const USER_OTP_CHANNEL_COLLECTION = 196;
export const USER_REQUIRE_OTP_COLLECTION = 191;
export const USER_CAPTCHA_COLLECTION = 195;
export const USER_ACCOUNT_COLLECTION = 197;
export const USER_404_COLLECTION = 201;
export const USER_EMAIL_COLLECTION = 241;
export const USER_PHONE_COLLECTION = 240;
export const USER_ONE_CREDENTIAL_MIGRATION_COLLECTION = 398;
export const USER_ONE_CREDENTIAL_ACCOUNT_BIND = 438;
export const USER_ACCEPT_INVITATION_COLLECTION = 549;
export const USER_ONE_CREDENTIAL_SWITCH_LINK_TOC = 593;
export const USER_SET_NEW_PASSWORD_COLLECTION = 631;
export const USER_NO_COST_AUTH_COLLECTION = 679;

// This is a shared collection for ToB app
// Currently, we put common transify values here, like keys for page placeholder
// Try not to abuse this collection by adding unnecessary transify keys inside
export const DEFAULT_COLLECTION = 203;
